module.exports = __webpack_public_path__ + "static/media/paper20.6bfa4567.jpg";